import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getTransferCompanyList as getTransferCompanyListApi,
	getTransferCompany as getTransferCompanyApi,
	addNewTransferCompany as addNewTransferCompanyApi,
	updateTransferCompany as updateTransferCompanyApi,
	deleteTransferCompany as deleteTransferCompanyApi,
	existsTransferCompany as existsTransferCompanyApi
} from '../../helpers/transfer/backend_helper';

export const getTransferCompanyList = createAsyncThunk('transferCompanies/getTransferCompanyList', async () => {
	try {
		const response = getTransferCompanyListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getTransferCompany = createAsyncThunk('transferCompanies/getTransferCompany', async transferCompany_id => {
	try {
		const response = getTransferCompanyApi(transferCompany_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const existsTransferCompany = createAsyncThunk('transferCompanies/existsTransferCompany', async rut => {
	try {
		const response = existsTransferCompanyApi(rut);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewTransferCompany = createAsyncThunk('transferCompanies/addNewTransferCompany', async transferCompany => {
	try {
		const response = addNewTransferCompanyApi(transferCompany);
		toast.success('Empresa de Transporte agregada exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar transferCompany.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateTransferCompany = createAsyncThunk('transferCompanies/updateTransferCompany', async (transferCompany) => {
		try {
			const response = updateTransferCompanyApi(transferCompany);
			toast.success('Empresa de Transporte actualizada exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar transferCompany.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteTransferCompany = createAsyncThunk('transferCompanies/deleteTransferCompany', async transferCompany => {
	try {
		const response = await deleteTransferCompanyApi(transferCompany);
		toast.success('Empresa de Transporte eliminada exitosamente.', { autoClose: 3000 });
		return { transferCompany, ...response };
	} catch (error) {
		toast.error('Error al eliminar transferCompany.', { autoClose: 3000 });
		throw new Error(error);
	}
});
